import { Module, PATH_DICTS_PROJECT_TYPES } from "@/constants";
import { fetchProjectTypeList } from "@/services/projectType";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect, { Option, type AsyncSelectBaseProps } from "./AsyncSelect";
import { EntityListLink } from "./EntityListLink";
import appConfiguration from "./cfg/AppCfg";

interface ProjectTypeSelectProps extends AsyncSelectBaseProps {
  className?: string;
  defaultItem?: Partial<Option>;
  projectDependsOn?: string;
  allowClearSelection?: boolean;
}
export default forwardRef<HTMLButtonElement, ProjectTypeSelectProps>(
  function ProjectTypeSelect({ defaultItem, projectDependsOn, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <span className="flex items-start gap-1">
        <span className="flex-1">
          <AsyncSelect
            queryKey={[Module.ProjectTypes]}
            queryFn={() =>
              fetchProjectTypeList({
                limit: appConfiguration.selectComponentsPaginationLimit,
              })
            }
            enableFilter={false}
            placeholder={t("projectTypeSelect.placeholder")}
            loadingLabel={t("projectTypeSelect.loadingProjectTypes")}
            {...props}
            defaultItem={defaultItem}
            ref={ref}
            className="w-full"
          />
          {projectDependsOn && (
            <span className="text-xs  text-gray-500">
              {t("projects.fields.project_depends_on")}:{" "}
              <strong>
                {t(`projects.enum.projectReportsDependOn.${projectDependsOn}`)}
              </strong>
            </span>
          )}
        </span>

        <EntityListLink
          path={PATH_DICTS_PROJECT_TYPES}
          label={t("projectTypeSelect.link")}
        />
      </span>
    );
  },
);
